import * as React from 'react';
import { ChangeEvent } from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import {
  TApiChemicalLocation,
} from '../../../types/Chemical';
import { useTranslation } from 'react-i18next';
import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

interface ICompanyProps {
  title: string;
  productIdentifier?: string;
  locations: Array<TApiChemicalLocation>;
  revisedDate: string;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
  panelId: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
  })
);


const Company: React.FC<ICompanyProps> = ({
  title,
  productIdentifier,
  locations,
  revisedDate,
  expanded,
  handleChange,
  panelId,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange(`panel${panelId}`)}
      key={`panel${panelId}`}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${panelId}bh-content`}
        id={`panel${panelId}bh-header`}
      >
        <Typography className={classes.heading}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
        {productIdentifier && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.product_identifier')}</b> <p>${productIdentifier}</p>` }} />
        )}
        {revisedDate && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.revised.date')}</b> <p>${revisedDate}</p>` }} />
        )}
        {(locations && locations.length > 0) && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.filter.location')}</b> <p>${
              locations.map((location) => {
                return location.title;
              }).join(', ')}</p>` }} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default Company;
